import {
  requestPublic,
  request
} from './request'

// 获取授权的菜单(树形结构)
export function getAuthorizeTheMenu() {
  // const sessionStorages = JSON.parse(sessionStorage.getItem("AdminCache"))
  // let id = '';
  // if (sessionStorages) {
  //     id = sessionStorages?.roles.find(item => item.isLoginIn)?.roleId
  // }
  return request({
      url: '/api4/SBCenterAdminApi/TheMenu/GetAuthorizeTheMenu',
      method: 'get',
      // params: {
      // rolesId: id,
      // },
  })
}




